import { HomePage } from "./pages/HomePage/index.js";

function App() {
  return <HomePage />;
}

export default App;
